export default {
  pageNotFound: 'Схоже, такої сторінки не існує :(',
  goToProjects: 'Перейти до проєктів',
  goToCandidates: 'Перейти до бази кандидатів'
}
